import { colors } from '@components/theme/styles/index';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { Box } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Container,
  ErrorIcon,
  ErrorLayout,
  HeaderBox,
  HeaderText,
} from './errorPage.styled';

export interface ErrorProps {
  icon?: IconDefinition;
  message?: string | React.ReactNode;
  color?: string;
}

const ErrorPage: FC<ErrorProps> = ({
  message,
  icon = faCircleExclamation,
  color = colors.danger,
}) => {
  const { t } = useTranslation('common');

  return (
    <ErrorLayout>
      <Container>
        <HeaderBox>
          <Box>
            <ErrorIcon accentcolor={color} icon={icon} />
          </Box>
          <Box>
            <HeaderText>{message ?? t('error.500')}</HeaderText>
          </Box>
        </HeaderBox>
      </Container>
    </ErrorLayout>
  );
};

export default ErrorPage;
